import * as yup from "yup";
import { useForm } from "vee-validate";

interface FormModel {
  email: string;
  password: string;
}

const defaultValues: FormModel = {
  email: "",
  password: "",
};

export default function useLoginForm(initialValues: FormModel = defaultValues) {
  const validationSchema = yup.object({
    email: yup.string().required().email("Please enter a valid email address"),
    password: yup.string().required(),
  });

  const form = useForm<FormModel>({
    validationSchema: validationSchema,
    initialValues,
  });

  return { form };
}
